/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from '../../utils/fp-js';

export const newMessageProcedureId = (state, action) =>
  FP.match(action.type)
    .on('SET_newMessageProcedureId', action.payload)
    .otherwise(state);
